import { Component, ContentChildren, Input, QueryList } from '@angular/core';
import { ItemWithID } from '@sb/library/base';
import { ProfileButtonComponent } from '../profile-button/profile-button.component';
import { MenuItemComponent } from '@sb/library/button';

@Component({
    selector: 'lib-profile-menu-button',
    templateUrl: './profile-menu-button.component.html',
    styleUrl: './profile-menu-button.component.scss'
})
export class ProfileMenuButtonComponent<T extends ItemWithID> extends ProfileButtonComponent<T> {
    @ContentChildren(MenuItemComponent) menuItemComponents!: QueryList<MenuItemComponent>;

    @Input() showAvatarOnly: boolean = false;
}
